var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 24,
    viewBox: "0 0 49 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.53846 0V7.5H0C0 3.36075 3.37798 0 7.53846 0Z",
    fill: "#2D53D1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.53846 8.25H0V15.75H7.53846V8.25Z",
    fill: "#2D53D1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.53846 16.5H0V24H7.53846V16.5Z",
    fill: "#2D53D1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.29231 0H15.8308C15.8308 4.13925 12.4528 7.5 8.29231 7.5V0Z",
    fill: "#2D53D1"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.29231 8.25H15.8308C15.8308 12.3893 12.4528 15.75 8.29231 15.75V8.25Z",
    fill: "#2D53D1"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1231 0V7.5H16.5846C16.5846 3.36075 19.9626 0 24.1231 0Z",
    fill: "#2D53D1"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5846 8.25H24.1231V15.75C19.9626 15.75 16.5846 12.3893 16.5846 8.25Z",
    fill: "#2D53D1"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1231 16.5V24H16.5846C16.5846 19.8608 19.9626 16.5 24.1231 16.5Z",
    fill: "#2D53D1"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M24.8769 0H32.4154C32.4154 4.13925 29.0374 7.5 24.8769 7.5V0Z",
    fill: "#2D53D1"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M24.8769 8.25C29.0374 8.25 32.4154 11.6108 32.4154 15.75H24.8769V8.25Z",
    fill: "#2D53D1"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M24.8769 16.5H32.4154C32.4154 20.6393 29.0374 24 24.8769 24V16.5Z",
    fill: "#2D53D1"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M40.7077 0V7.5H33.1692C33.1692 3.36075 36.5472 0 40.7077 0Z",
    fill: "#2D53D1"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M40.7077 8.25H33.1692V15.75H40.7077V8.25Z",
    fill: "#2D53D1"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M33.1692 16.5H40.7077V24C36.5472 24 33.1692 20.6393 33.1692 16.5Z",
    fill: "#2D53D1"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M41.4615 0H49C49 4.13925 45.622 7.5 41.4615 7.5V0Z",
    fill: "#2D53D1"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M49 12H41.4615V15.75H49V12Z",
    fill: "#2D53D1"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M49 16.5H41.4615V24H49V16.5Z",
    fill: "#2D53D1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.e16376a0f51174988b00d203bf64c330.svg";
export { ForwardRef as ReactComponent };